var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 34,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M14.49 6.014v3.84s-1.577-.008-2.216-.008c-1.252 0-1.166.488-1.166 2.032v1.144h3.38l-.61 3.994h-2.77v10.728H6.414V17.016H4.1v-3.994h2.314V9.81s-.04-1.78 1.417-2.89c1.32-.998 2.87-.918 2.87-.918l3.8.012z"
  })));
}
export default SvgFacebookIcon;